import { render, staticRenderFns } from "./BotaoConfirmarNovoTokenCallback.vue?vue&type=template&id=04b1e83a&scoped=true&"
import script from "./BotaoConfirmarNovoTokenCallback.vue?vue&type=script&lang=js&"
export * from "./BotaoConfirmarNovoTokenCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b1e83a",
  null
  
)

export default component.exports